import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsCallInTypeUpdate = (isAdmin = false) => {
  return dispatch => {
    var url = url = UrlServer.URL_POST_CALL_IN_TYPE
    if(isAdmin){
      url = UrlServer.URL_POST_CALL_IN_TYPE_ADMIN
    }
    APIGet(url, datas => {
      dispatch({ type: actionTypes.LISTS_CALL_IN_TYPE_UPDATE, listsCallInType: datas.datas })
    })
  }
}
